import * as React from "react";
import LiveCommentsReportService from "../../../services/reports.service";
import { usePaginatedFetch } from "./usePaginatedFetch";

export function useLivesReports(args) {
  const fetcher = React.useCallback(
    (p, ps) => LiveCommentsReportService.getLiveCommentReports(p, ps),
    []
  );

  const live = usePaginatedFetch({
    enabled: args.enabled,
    auto: true,
    initialPage: 1,
    pageSize: 20,
    fetcher,
  });

  React.useEffect(() => {
    if (args.enabled) live.resetPage();
  }, [args.enabled, live.resetPage]);

  return live;
}
